// https://www.iana.org/assignments/icmpv6-parameters/icmpv6-parameters.xhtml
// note: 202-254 are consider to be 'Unassigned' (these type values are not mentioned in the IANA list)
// Keys were extended by Extreme Xos Docs.
// https://documentation.extremenetworks.com/exos_30.6/GUID-CE70CD79-E759-4306-B3E2-ABD6CFD30967.shtml#GUID-CE70CD79-E759-4306-B3E2-ABD6CFD30967__I967141

/*
Cisco ACI/APIC - https://pubhub.devnetcloud.com/media/apic-mim-ref-301/docs/TYPE-icmpv6-Type.html
  dst-unreach 1 Destination Unreachable Destination Unreachable
  time-exceeded 3 Time Exceeded Time Exceeded
  echo-req 128 Echo Request Echo Request
  echo-rep 129 Echo Reply Echo Reply
  nbr-solicit 135 Neighbor Solicitation Neighbor Solicitation
  nbr-advert 136 Neighbor Advertisement Neighbor Advertisement
  redirect 137 Redirect Message Redirect Message
*/

export type Icmp6Type = {
  type: number;
  name: string;
  keys?: string[];
};

export function icmp6Types(): Icmp6Type[] {
  return [
    { type: 0, name: 'Reserved' },
    {
      type: 1,
      name: 'Destination Unreachable',
      keys: ['unreachable', 'v6-unreachable', 'dst-unreach'],
    },
    {
      type: 2,
      name: 'Packet Too Big',
      keys: ['packet-too-big', 'v6-packet-too-big'],
    },
    {
      type: 3,
      name: 'Time Exceeded',
      keys: ['time-exceeded', 'v6-time-exceeded'],
    },
    {
      type: 4,
      name: 'Parameter Problem',
      keys: ['parameter-problem', 'v6-parameter-problem'],
    },
    { type: 5, name: 'Unassigned' },
    { type: 6, name: 'Unassigned' },
    { type: 7, name: 'Unassigned' },
    { type: 8, name: 'Unassigned' },
    { type: 9, name: 'Unassigned' },
    { type: 10, name: 'Unassigned' },
    { type: 11, name: 'Unassigned' },
    { type: 12, name: 'Unassigned' },
    { type: 13, name: 'Unassigned' },
    { type: 14, name: 'Unassigned' },
    { type: 15, name: 'Unassigned' },
    { type: 16, name: 'Unassigned' },
    { type: 17, name: 'Unassigned' },
    { type: 18, name: 'Unassigned' },
    { type: 19, name: 'Unassigned' },
    { type: 20, name: 'Unassigned' },
    { type: 21, name: 'Unassigned' },
    { type: 22, name: 'Unassigned' },
    { type: 23, name: 'Unassigned' },
    { type: 24, name: 'Unassigned' },
    { type: 25, name: 'Unassigned' },
    { type: 26, name: 'Unassigned' },
    { type: 27, name: 'Unassigned' },
    { type: 28, name: 'Unassigned' },
    { type: 29, name: 'Unassigned' },
    { type: 30, name: 'Unassigned' },
    { type: 31, name: 'Unassigned' },
    { type: 32, name: 'Unassigned' },
    { type: 33, name: 'Unassigned' },
    { type: 34, name: 'Unassigned' },
    { type: 35, name: 'Unassigned' },
    { type: 36, name: 'Unassigned' },
    { type: 37, name: 'Unassigned' },
    { type: 38, name: 'Unassigned' },
    { type: 39, name: 'Unassigned' },
    { type: 40, name: 'Unassigned' },
    { type: 41, name: 'Unassigned' },
    { type: 42, name: 'Unassigned' },
    { type: 43, name: 'Unassigned' },
    { type: 44, name: 'Unassigned' },
    { type: 45, name: 'Unassigned' },
    { type: 46, name: 'Unassigned' },
    { type: 47, name: 'Unassigned' },
    { type: 48, name: 'Unassigned' },
    { type: 49, name: 'Unassigned' },
    { type: 50, name: 'Unassigned' },
    { type: 51, name: 'Unassigned' },
    { type: 52, name: 'Unassigned' },
    { type: 53, name: 'Unassigned' },
    { type: 54, name: 'Unassigned' },
    { type: 55, name: 'Unassigned' },
    { type: 56, name: 'Unassigned' },
    { type: 57, name: 'Unassigned' },
    { type: 58, name: 'Unassigned' },
    { type: 59, name: 'Unassigned' },
    { type: 60, name: 'Unassigned' },
    { type: 61, name: 'Unassigned' },
    { type: 62, name: 'Unassigned' },
    { type: 63, name: 'Unassigned' },
    { type: 64, name: 'Unassigned' },
    { type: 65, name: 'Unassigned' },
    { type: 66, name: 'Unassigned' },
    { type: 67, name: 'Unassigned' },
    { type: 68, name: 'Unassigned' },
    { type: 69, name: 'Unassigned' },
    { type: 70, name: 'Unassigned' },
    { type: 71, name: 'Unassigned' },
    { type: 72, name: 'Unassigned' },
    { type: 73, name: 'Unassigned' },
    { type: 74, name: 'Unassigned' },
    { type: 75, name: 'Unassigned' },
    { type: 76, name: 'Unassigned' },
    { type: 77, name: 'Unassigned' },
    { type: 78, name: 'Unassigned' },
    { type: 79, name: 'Unassigned' },
    { type: 80, name: 'Unassigned' },
    { type: 81, name: 'Unassigned' },
    { type: 82, name: 'Unassigned' },
    { type: 83, name: 'Unassigned' },
    { type: 84, name: 'Unassigned' },
    { type: 85, name: 'Unassigned' },
    { type: 86, name: 'Unassigned' },
    { type: 87, name: 'Unassigned' },
    { type: 88, name: 'Unassigned' },
    { type: 89, name: 'Unassigned' },
    { type: 90, name: 'Unassigned' },
    { type: 91, name: 'Unassigned' },
    { type: 92, name: 'Unassigned' },
    { type: 93, name: 'Unassigned' },
    { type: 94, name: 'Unassigned' },
    { type: 95, name: 'Unassigned' },
    { type: 96, name: 'Unassigned' },
    { type: 97, name: 'Unassigned' },
    { type: 98, name: 'Unassigned' },
    { type: 99, name: 'Unassigned' },
    { type: 100, name: 'Private experimentation' },
    { type: 101, name: 'Private experimentation' },
    { type: 102, name: 'Unassigned' },
    { type: 103, name: 'Unassigned' },
    { type: 104, name: 'Unassigned' },
    { type: 105, name: 'Unassigned' },
    { type: 106, name: 'Unassigned' },
    { type: 107, name: 'Unassigned' },
    { type: 108, name: 'Unassigned' },
    { type: 109, name: 'Unassigned' },
    { type: 110, name: 'Unassigned' },
    { type: 111, name: 'Unassigned' },
    { type: 112, name: 'Unassigned' },
    { type: 113, name: 'Unassigned' },
    { type: 114, name: 'Unassigned' },
    { type: 115, name: 'Unassigned' },
    { type: 116, name: 'Unassigned' },
    { type: 117, name: 'Unassigned' },
    { type: 118, name: 'Unassigned' },
    { type: 119, name: 'Unassigned' },
    { type: 120, name: 'Unassigned' },
    { type: 121, name: 'Unassigned' },
    { type: 122, name: 'Unassigned' },
    { type: 123, name: 'Unassigned' },
    { type: 124, name: 'Unassigned' },
    { type: 125, name: 'Unassigned' },
    { type: 126, name: 'Unassigned' },
    { type: 127, name: 'Reserved for expansion of ICMPv6 error messages' },
    {
      type: 128,
      name: 'Echo Request',
      keys: ['echo', 'v6-echo-request', 'echo-req'],
    },
    {
      type: 129,
      name: 'Echo Reply',
      keys: ['echo-reply', 'v6-echo-reply', 'echo-rep'],
    },
    {
      type: 130,
      name: 'Multicast Listener Query',
      keys: ['membership-query', 'v6-mld-query'],
    },
    {
      type: 131,
      name: 'Multicast Listener Report',
      keys: ['membership-report', 'v6-mld-report'],
    },
    {
      type: 132,
      name: 'Multicast Listener Done',
      keys: ['membership-reduction', 'v6-mld-reduction'],
    },
    {
      type: 133,
      name: 'Router Solicitation',
      keys: ['router-solicitation', 'v6-router-soliciation'],
    },
    {
      type: 134,
      name: 'Router Advertisement',
      keys: ['router-advertisement', 'v6-router-advertisement'],
    },
    {
      type: 135,
      name: 'Neighbor Solicitation',
      keys: [
        'neighbor-solicitation',
        'v6-neighbor-solicitation',
        'nbr-solicit',
      ],
    },
    {
      type: 136,
      name: 'Neighbor Advertisement',
      keys: [
        'neighbor-advertisement',
        'v6-neighbor-advertisement',
        'nbr-advert',
      ],
    },
    {
      type: 137,
      name: 'Redirect Message',
      keys: ['neighbor-redirect', 'v6-redirect', 'redirect'],
    },
    { type: 138, name: 'Router Renumbering', keys: ['router-renumbering'] },
    {
      type: 139,
      name: 'ICMP Node Information Query',
      keys: ['v6-node-info-query'],
    },
    {
      type: 140,
      name: 'ICMP Node Information Response',
      keys: ['v6-node-info-reply'],
    },
    { type: 141, name: 'Inverse Neighbor Discovery Solicitation Message' },
    { type: 142, name: 'Inverse Neighbor Discovery Advertisement Message' },
    { type: 143, name: 'Version 2 Multicast Listener Report' },
    { type: 144, name: 'Home Agent Address Discovery Request Message' },
    { type: 145, name: 'Home Agent Address Discovery Reply Message' },
    { type: 146, name: 'Mobile Prefix Solicitation' },
    { type: 147, name: 'Mobile Prefix Advertisement' },
    { type: 148, name: 'Certification Path Solicitation Message' },
    { type: 149, name: 'Certification Path Advertisement Message' },
    {
      type: 150,
      name: 'ICMP messages utilized by experimental mobility protocols such as Seamoby',
    },
    { type: 151, name: 'Multicast Router Advertisement' },
    { type: 152, name: 'Multicast Router Solicitation' },
    { type: 153, name: 'Multicast Router Termination' },
    { type: 154, name: 'FMIPv6 Messages' },
    { type: 155, name: 'RPL Control Message' },
    { type: 156, name: 'ILNPv6 Locator Update Message' },
    { type: 157, name: 'Duplicate Address Request' },
    { type: 158, name: 'Duplicate Address Confirmation' },
    { type: 159, name: 'MPL Control Message' },
    { type: 160, name: 'Extended Echo Request' },
    { type: 161, name: 'Extended Echo Reply' },
    { type: 162, name: 'Unassigned' },
    { type: 163, name: 'Unassigned' },
    { type: 164, name: 'Unassigned' },
    { type: 165, name: 'Unassigned' },
    { type: 166, name: 'Unassigned' },
    { type: 167, name: 'Unassigned' },
    { type: 168, name: 'Unassigned' },
    { type: 169, name: 'Unassigned' },
    { type: 170, name: 'Unassigned' },
    { type: 171, name: 'Unassigned' },
    { type: 172, name: 'Unassigned' },
    { type: 173, name: 'Unassigned' },
    { type: 174, name: 'Unassigned' },
    { type: 175, name: 'Unassigned' },
    { type: 176, name: 'Unassigned' },
    { type: 177, name: 'Unassigned' },
    { type: 178, name: 'Unassigned' },
    { type: 179, name: 'Unassigned' },
    { type: 180, name: 'Unassigned' },
    { type: 181, name: 'Unassigned' },
    { type: 182, name: 'Unassigned' },
    { type: 183, name: 'Unassigned' },
    { type: 184, name: 'Unassigned' },
    { type: 185, name: 'Unassigned' },
    { type: 186, name: 'Unassigned' },
    { type: 187, name: 'Unassigned' },
    { type: 188, name: 'Unassigned' },
    { type: 189, name: 'Unassigned' },
    { type: 190, name: 'Unassigned' },
    { type: 191, name: 'Unassigned' },
    { type: 192, name: 'Unassigned' },
    { type: 193, name: 'Unassigned' },
    { type: 194, name: 'Unassigned' },
    { type: 195, name: 'Unassigned' },
    { type: 196, name: 'Unassigned' },
    { type: 197, name: 'Unassigned' },
    { type: 198, name: 'Unassigned' },
    { type: 199, name: 'Unassigned' },
    { type: 200, name: 'Private experimentation' },
    { type: 201, name: 'Private experimentation' },
    { type: 202, name: 'Unassigned' },
    { type: 203, name: 'Unassigned' },
    { type: 204, name: 'Unassigned' },
    { type: 205, name: 'Unassigned' },
    { type: 206, name: 'Unassigned' },
    { type: 207, name: 'Unassigned' },
    { type: 208, name: 'Unassigned' },
    { type: 209, name: 'Unassigned' },
    { type: 210, name: 'Unassigned' },
    { type: 211, name: 'Unassigned' },
    { type: 212, name: 'Unassigned' },
    { type: 213, name: 'Unassigned' },
    { type: 214, name: 'Unassigned' },
    { type: 215, name: 'Unassigned' },
    { type: 216, name: 'Unassigned' },
    { type: 217, name: 'Unassigned' },
    { type: 218, name: 'Unassigned' },
    { type: 219, name: 'Unassigned' },
    { type: 220, name: 'Unassigned' },
    { type: 221, name: 'Unassigned' },
    { type: 222, name: 'Unassigned' },
    { type: 223, name: 'Unassigned' },
    { type: 224, name: 'Unassigned' },
    { type: 225, name: 'Unassigned' },
    { type: 226, name: 'Unassigned' },
    { type: 227, name: 'Unassigned' },
    { type: 228, name: 'Unassigned' },
    { type: 229, name: 'Unassigned' },
    { type: 230, name: 'Unassigned' },
    { type: 231, name: 'Unassigned' },
    { type: 232, name: 'Unassigned' },
    { type: 233, name: 'Unassigned' },
    { type: 234, name: 'Unassigned' },
    { type: 235, name: 'Unassigned' },
    { type: 236, name: 'Unassigned' },
    { type: 237, name: 'Unassigned' },
    { type: 238, name: 'Unassigned' },
    { type: 239, name: 'Unassigned' },
    { type: 240, name: 'Unassigned' },
    { type: 241, name: 'Unassigned' },
    { type: 242, name: 'Unassigned' },
    { type: 243, name: 'Unassigned' },
    { type: 244, name: 'Unassigned' },
    { type: 245, name: 'Unassigned' },
    { type: 246, name: 'Unassigned' },
    { type: 247, name: 'Unassigned' },
    { type: 248, name: 'Unassigned' },
    { type: 249, name: 'Unassigned' },
    { type: 250, name: 'Unassigned' },
    { type: 251, name: 'Unassigned' },
    { type: 252, name: 'Unassigned' },
    { type: 253, name: 'Unassigned' },
    { type: 254, name: 'Unassigned' },
    {
      type: 255,
      name: 'Reserved for expansion of ICMPv6 informational messages',
    },
  ];
}
